import { SideNavAction, SideNavActionTypes } from '../actions/SideNavActions';

export interface SideNavState {
    opened: boolean 
}

const INITIAL_STATE: SideNavState = {
    opened: false   
};

export default function (state = INITIAL_STATE, action: SideNavAction): SideNavState {
    switch (action.type) {
        case SideNavActionTypes.TOGGLE_SIDENAV:
            return {
                opened: !state.opened
            };
        default:
            return state;
    }
}